/**
 *
 * @param {string} media
 * @returns
 */
export async function detectMediaType(media: string): Promise<string | null> {
  try {
    const mediaRes = await fetch(media);
    const data = await mediaRes.blob();
    const type = data.type;
    return type.includes("video") ? "video_url" : "image_url";
  } catch (e) {
    console.error(e);
    return null;
  }
}
